import styles from "./confirmDialog.module.scss";
import { Modal } from "@monta/design-system";

export interface ConfirmDialogProps {
  onConfirm: () => void;
  message: string;
  primaryChoice?: "yes" | "no";
  controller: {
    isOpen: boolean;
    open(): void;
    close(): void;
    onOpen(cb: () => void): void;
    onClose(cb: () => void): void;
  };
}

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const { message, onConfirm, controller, primaryChoice = "yes" } = props;
  const onClose = () => {
    controller.close();
  };

  const confirmHandler = () => {
    controller.close();
    onConfirm();
  };
  const content = (
    <div className={styles["dialog"]}>
      <p>{message}</p>
      <div className={styles["dialog__actions"]}>
        {primaryChoice === "no" ? (
          <>
            <button onClick={confirmHandler}>بله</button>
            <button onClick={onClose}>خیر</button>
          </>
        ) : (
          <>
            <button onClick={onClose}>خیر</button>
            <button onClick={confirmHandler}>بله</button>
          </>
        )}
      </div>
    </div>
  );
  return (
    <>
      <Modal
        {...controller}
        bottomSheetOnMobile
        borderRadius="5"
        minWidth={400}
        maxWidth={603}
      >
        {content}
      </Modal>
    </>
  );
};

export default ConfirmDialog;
